<template>
  <div>
    <div class="ls-con-conu">
      <div class="content-top">
        <div class="user-scical space-between">
          <div class="flex">
            <img class="userImg" :src="userInfo.head_photo" />
            <div>
              <div class="name">{{userInfo.user_name}}</div>
              <div class="subName">{{userInfo.position}}</div>
            </div>
          </div>
          <div class="log_im">
            <img :src="imgPath+'yj_logo.jpeg'" alt />
          </div>
        </div>
        <!--  -->
        <div class="flex user-function" v-if="userInfo.tel">
          <img
            src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/five-phone.png"
            alt
          />
          {{userInfo.tel}}
        </div>
        <div class="flex user-function" v-if="userInfo.wechat_number">
          <img
            src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/five-wechat.png"
            alt
          />
          {{userInfo.wechat_number}}
        </div>
        <div class="flex user-function" v-if="userInfo.email">
          <img
            src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/five-email.png"
            alt
          />
          {{userInfo.email}}
        </div>
        <div class="flex user-function" v-if="userInfo.address">
          <img
            src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/five-city.png"
            alt
          />
          {{userInfo.address}}
        </div>
      </div>
      <!--  -->
      <div class="content-top space-between nav-info">
        <div class="n_comit" v-if="userInfo.tel">
          <img
            src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/five-phone.png"
            alt
          />
          <p @click="callPhone">打电话</p>
        </div>
        <div
          class="n_comit"
          @click="copyTextFg(userInfo.wechat_number)"
          v-if="userInfo.wechat_number"
        >
          <img
            src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/five-wechat.png"
            alt
          />
          <p>转发名片</p>
        </div>
        <div
          class="n_comit"
          @click="copyTextFg(userInfo.wechat_number)"
          v-if="userInfo.wechat_number"
        >
          <img
            src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/five-email.png"
            alt
          />
          <p>加微信</p>
        </div>
        <div class="n_comit" @click="copyTextFg(userInfo.tel)" v-if="userInfo.tel">
          <img
            src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/five-city.png"
            alt
          />
          <p>存电话</p>
        </div>
        <!-- <div class="n_comit">
          <img
            src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/five-city.png"
            alt
          />
          <p>导航</p>
        </div>-->
      </div>
      <div class="n_pink">
        <div>
          <div class="n_left flex">
            <div class="n_imguser">
              <!-- <div v-if="userInfo.view_list && userInfo.view_list.length > 0" style="display:flex"> -->
              <img class="n_imgs" v-for="i in userInfo.view_list" :key="i.id" :src="i.avatar" alt />
              <!-- </div> -->
              <span class="n_mlleft">浏览人数{{userInfo.view_num}}</span>
            </div>
            <div class="n_muzhi" @click="userInfo.is_like ? '' : setView({type: 'like'})">
              <span>点赞</span>
              <span :class="['iconfont', 'iconz-likeFill',userInfo.is_like ? '' : 'like_c']"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="n_vido" v-if="userInfo.video_path">
        <div class="flex align_center">
          <span class="iconfont iconbofang"></span>
          <p class="n_title">我的视频</p>
        </div>
        <video class="n_videowidth" controls :poster="userInfo.video_img">
          <source :src="userInfo.video_path" type="video/mp4" />
          <source src="movie.ogg" type="video/ogg" />您的浏览器不支持Video标签。
        </video>
      </div>
      <div class="n_vido">
        <div class="flex align_center">
          <span class="iconfont iconyonghutouxiang"></span>
          <p class="n_title">个人介绍</p>
        </div>
        <div class="n_usercontent" v-html="userInfo.profile"></div>
      </div>
      <div class="flex n_flexwarp">
        <div
          class="flex n_lable"
          v-for="(i,index) in userInfo.effect_tag_list"
          :key="i.name"
          @click="saveEffectTaglist(index)"
        >
          <p>{{i.name}}</p>
          <span class="iconfont iconz-likeFill"></span>
          <p>{{i.like_num}}</p>
        </div>
      </div>
      <div class="flex justify_buttwe" v-if="userInfo.goods_list && userInfo.goods_list.length > 0">
        <div class="flex align_center">
          <span class="iconfont iconyonghutouxiang icon_width"></span>
          <p class="n_title">推荐商品</p>
        </div>
        <div class="flex align_center">
          <!-- <p class="n_conc">查看更多</p> -->
          <span class="iconfont iconnext"></span>
        </div>
      </div>
      <div class="my-swipe flex">
        <div
          class="n_goods"
          v-for="i in userInfo.goods_list"
          :key="i.id"
          @click="$router.push({path: './shopDetails',query:{goods_id: i.id}})"
        >
          <div class="n_goodsimg">
            <img :src="i.images" alt />
          </div>
          <div class="n_goodstitle">{{i.goods_name}}</div>
          <div class="flex justify_buttwe">
            <div class="n_pricered">¥{{i.price}}</div>
            <!-- <div class="n_pricec">¥{{i.market_price}}</div> -->
          </div>
        </div>
      </div>
      <div class="n_vido" v-if="userInfo.wall_photo && userInfo.wall_photo.length > 0">
        <div class="flex align_center">
          <span class="iconfont iconyonghutouxiang"></span>
          <p class="n_title">我的照片</p>
        </div>
        <div class="n_userImg" v-for="i in userInfo.wall_photo" :key="i">
          <img :src="i" alt style="vertical-align: top;" />
        </div>
      </div>
    </div>
    <img class="card_list" @click="jump" :src="imgPath +'yj_card.png'" alt />
    <div class="n_height"></div>
  </div>
</template>

<script>
import { copyText } from '../../public/regular.js'
import { analysisUrl } from '../../public/public.js'
import http from '../../../http.js'
import wx from 'weixin-js-sdk'
import share from '../../public/share.js'
import { Toast } from 'vant'
export default {
  data() {
    return {
      userInfo: {},
      queryParam: { page: 0, limit: 10, user_name: '' },
      cardId: '',
      id: '',
    }
  },
  created() {
    if (!this.$route.query.id) {
      this.http('BusCard.getJumpPage').then((e) => {
        console.log(e)
        if (e.content.id) {
          this.id = e.content.id
          this.getUsertInfo(e.content.id)
          this.setView({ type: 'view', card_id: e.content.id })
        }
      })
    } else {
      console.log(this.$route.query.id)
      if (this.$route.query.id) {
        this.getUsertInfo(this.$route.query.id)
        this.id = this.$route.query.id
        this.setView({ type: 'view', card_id: this.$route.query.id })
      }
    }
    this.$store.commit('activeFailure', 1)
    let url = analysisUrl(window.location.href)
    if (url.qr_keys) {
      localStorage.setItem('cardId', url.id)
      this.bindCardFg(url.qr_keys)
    }
    // if (this.$route.query.id) {
    // } else if (localStorage.getItem('cardId')) {
    //   this.getUsertInfo(JSON.parse(localStorage.getItem('cardId')))
    // } else {
    //   this.getList()
    // }
  },
  watch: {
    '$store.state.shareStr': function (e) {
      if (e == 'social') {
        this.shareModelFg()
      }
    },
  },
  mounted() {
    this.getUrl()
  },
  methods: {
    shareModelFg() {
      let uid
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      let url =
        window.location.href.split('?')[0] +
        '?type=share' +
        '&uid=' +
        uid +
        '&scenes=bus_card' +
        '&id=' +
        this.id
      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      })
      let shareInfo = {
        title: `您好，我是${this.userInfo.user_name}，这是我的名片请惠存_好酒尽在壹酒叮咚~~`,
        desc: '壹玖叮咚_您身边的名酒专家_好酒尽在壹酒叮咚~~',
        link: url, // 分享链接，该链接域名必须与当前企业的可信域名一致'
        imgUrl:
          'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yi_logo.jpg',
      }
      wx.onMenuShareAppMessage(shareInfo)
      wx.onMenuShareTimeline(shareInfo)
    },
    getUrl() {
      let urk = analysisUrl(window.location.href)
      localStorage.setItem('shareInfo', JSON.stringify(urk))
      if (urk.type == 'share') {
        this.shareExtensionFg(urk)
      } else if (JSON.parse(localStorage.getItem('shareInfo')).uid) {
        this.shareExtensionFg(JSON.parse(localStorage.getItem('shareInfo')))
      }
    },
    //分享关系
    async shareExtensionFg(obj) {
      let res = await this.http('Client.shareExtension', {
        share_member_id: obj.uid,
        share_staff_id: obj.share_staff_id || 0,
        scenes: obj.scenes,
        extend_id: obj.id,
      })
      localStorage.setItem('shareId', res.content.share_sign_no)
      // 查看是否有红包
      if (res.content.share_sign_no) {
        this.receiveShareRedPacket(res.content.share_sign_no)
      }
      console.log(res)
    },
    // 领取分享新用户得红包  有分享关系请求
    receiveShareRedPacket(id) {
      this.http('MemberRedPacket.receiveShareRedPacket', {
        share_sign_no: id,
      }).then((e) => {
        console.log(e)
      })
    },
    //绑定名片
    async bindCardFg(id) {
      let res = await http('BusCard.bindMember', { qrcode_keys: id })
      console.log(res)
    },
    jump() {
      this.$router.push({ path: 'businessList' })
    },
    //获取名片列表
    async getList() {
      let res = await this.http('BusCard.getMchCardList', this.queryParam)
      if (res.content.list && res.content.list.length > 0) {
        console.log(res)
        this.cardId = res.content.list[0].id
        this.getUsertInfo(this.cardId)
      }
    },
    // 拨打电话
    callPhone() {
      window.location.href = 'tel://' + this.userInfo.tel
    },
    copyTextFg(text) {
      copyText(text)
    },
    async getUsertInfo(id) {
      console.log(id)
      let { content, status } = await this.http('BusCard.getMchCardInfo', {
        card_id: id,
      })
      console.log(content)
      this.userInfo = content
      this.userInfo.view_list = this.userInfo.view_list.slice(0, 4)
      localStorage.setItem('cardHead', content.head_photo) //当前名片头像
      if (this.$store.state.shareStr != 'social') {
        new share(
          {
            startUrl: window.location.href,
          },
          this.$store,
          'social'
        )
      } else {
        this.shareModelFg()
      }
    },
    // 名片浏览|点赞-
    async setView(params) {
      console.log(params)
      params.card_id = this.id
      let res = await this.http('BusCard.setView', {
        ...params,
      })
      if (res.status == 200) {
        if (params.type == 'like') {
          this.userInfo.is_like = true
        } else {
        }
      } else {
        Toast(res.msg)
      }
      console.log(res)
    },
    // 印象标签点赞
    saveEffectTaglist(index) {
      this.userInfo.effect_tag_list[index].like_num += 1
      let list = {}
      this.userInfo.effect_tag_list.map((item) => {
        list[item.name] = item.like_num
      })
      this.http('BusCard.saveEffectTag', {
        card_id: this.$route.query.id,
        data: list,
      }).then((res) => {
        console.log(res)
      })
    },
  },
}
</script>
<style scoped lang="scss">
.ls-con-conu {
  width: 690px;
  margin: 0 auto;
}
.content-top {
  box-sizing: border-box;
  background: #ffffff;
  margin: 23px auto;
  padding: 0 30px;
  box-shadow: 2px 2px 14px 0px rgba(186, 186, 186, 0.3);
  border-radius: 18px;
}
.user-scical {
  padding: 33px 0;
  border-bottom: 1px solid #e9eaeb;
}
.user-scical .userImg {
  width: 86px;
  height: 86px;
  background: #dbe5f1;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 20px;
}
.user-scical .log_im {
  width: 80px;
  height: 80px;
  background: #cecece;
  border-radius: 10px;
}
.log_im image {
  width: 80px;
  height: 80px;
  border-radius: 10px;
}
.user-scical {
  margin-bottom: 30px;
}
.user-scical .name {
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  color: #000000;
  line-height: 42px;
}
.user-scical .subName {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  width: 400px;
  line-height: 42px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
.im {
  width: 100%;
  height: 100%;
}
.space-between {
  display: flex;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.user-function {
  align-items: center;
  padding-bottom: 19px;
}
.user-function img {
  width: 32px;
  height: 32px;
  margin-right: 20px;
}
.nav-info {
  height: 139px;
  align-items: center;
}
.n_comit img {
  display: block;
  width: 42px;
  height: 42px;
  margin: 0 auto;
}
.n_comit p {
  font-size: 24px;
  color: #000000;
  text-align: center;
}
.n_videowidth {
  width: 690px;
  height: 408px;
}
.align_center {
  align-items: center;
}
.n_title {
  font-size: 30px;
  color: #333333;
  margin-left: 10px;
}
.n_usercontent {
  width: 690px;
  min-height: 250px;
  border-radius: 12px;
}
.n_flexwarp {
  flex-wrap: wrap;
}
.n_lable {
  padding: 10px 15px;
  align-items: center;
  color: rgba(255, 120, 30, 1);
  background: #f9f3ed;
  border-radius: 24px;
  font-size: 22px;
  color: #ff781e;
  margin-right: 20px;

  margin-bottom: 20px;
}
.n_lable p {
  padding: 0;
  margin: 0;
}
.iconz-likeFill {
  color: rgba(255, 120, 30, 1);
  margin: 0 7px;
}
.justify_buttwe {
  justify-content: space-between;
}
.icon_width {
  font-size: 30px;
}
.n_conc {
  font-size: 26px;
  color: #999999;
}
.n_goods {
  width: 258px !important;
  background: #ffffff;
  border-radius: 18px;
  box-sizing: border-box;
  padding: 20px;
}
.n_goodsimg {
  width: 220px;
  height: 220px;
}
img {
  width: 100%;
  height: 100%;
}
.n_goodstitle {
  height: 66px;
  font-size: 24px;
  color: #333333;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 10px 0 16px 0;
}
.n_pricered {
  font-size: 24px;
  color: #ff3b30;
}
.n_pricec {
  font-size: 24px;
  color: #bbbbbb;
}
.my-swipe {
  overflow: hidden;
  overflow-x: scroll;
}
.my-swipe::-webkit-scrollbar {
  display: none;
}
.n_userImg {
  background: #d8d8d8;
  border-radius: 18px;
}
.n_height {
  height: 120px;
}
.n_imguser {
  display: flex;
  align-items: center;
}
.n_imgs {
  position: relative;
  width: 46px;
  height: 46px;
  border-radius: 50%;
}
.n_imgs:nth-child(1) {
  // margin-left: 10px;
  // left: 20px;
}
.n_imgs:nth-child(2) {
  // left: 40px;
  margin-left: -20px;
}
.n_imgs:nth-child(3) {
  // left: 60px;
  margin-left: -20px;
}
.n_imgs:nth-child(4) {
  margin-left: -20px;
  // left: 80px;
}
.n_left {
  justify-content: space-between;
  padding: 32px 30px 20px 30px;
}
.n_pink {
  width: 100%;
  background: #ffe9e9;
  border-radius: 10px;
  .like_c {
    color: #ccc !important;
  }
}
.n_mlleft {
  margin-left: 20px;
  font-size: 22px;
  color: #999999;
}
.card_list {
  position: fixed;
  top: 0;
  left: 0;
  width: 50px;
  height: 50px;
}
</style>